import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { CoachingInterventions } from './CoachingInterventions'
import { CoachingInterventionDetail } from './CoachingInterventionDetail'

export const CoachingInterventionsWidget: React.FC = () => (
  <Switch>
    <Route
      path='/internal/self-serve/coaching-interventions/:id'
      component={CoachingInterventionDetail}
    />
    <Route
      path='/internal/self-serve/coaching-interventions'
      component={CoachingInterventions}
    />
  </Switch>
)
